module.exports = __webpack_public_path__ + "images/hyundai7ac633c6763c05d0a6ecb1ab7554a5a7.png";